<template>
    <!-- 对话框 -->
    <el-dialog title="配置信息" :visible.sync="show" :before-close="closeDialog" width="80%" style="margin: 0 auto;">

        <!-- 基本信息表单 -->
        <div class="form-box">


            <el-form ref="form" :model="submit_data" label-width="80px" style="overflow-y: auto; ">
                <div>
                    <el-form-item label="活动开关:">
                        <el-select v-model="submit_data.status" placeholder="请选择状态"
                            style="width: 180px; margin-right: 20px;">
                            <el-option label="开启" value="1">
                            </el-option>

                            <el-option label="关闭" value="0">
                            </el-option>

                        </el-select>

                    </el-form-item>

                </div>
                <!-- 选择优惠券模式 -->

                <div class="active_config">乘客端奖励配置</div>

                <el-form-item label="优惠券:">
                    <el-select v-model="value_Coupon_code" placeholder="请选择优惠券" @visible-change="couponVisibleChange"
                        @change="couponChange" clearable style="width: 180px; margin-right: 20px;">
                        <el-option v-for="item in options_coupon_code" :key="item.value" :label="item.name"
                            :value="item.coupon_mode_code">
                        </el-option>

                        <selectPages :search_data="coupon_options_data" :result_data="selectPages_data"
                            @selectPages_function="selectPages_function"></selectPages>

                    </el-select>

                </el-form-item>




                <div>

                    <div style="display: flex;justify-content: space-between;align-items: center;">

                        <div class="active_config">司机端奖励配置</div>

                        <el-button @click="addRules" type="text" style="float: right">+增加设置</el-button>




                    </div>
                </div>



                <el-table :data="scoreTableData" style="width: 100%" ref="multipleTable"
                    header-cell-class-name="table-header">


                    <el-table-column prop="reward_rule" label="累计人数(包含)">
                        <template slot-scope="props">

                            <el-input v-model="props.row.num" placeholder="累计人数"></el-input>

                        </template>

                    </el-table-column>

                    <el-table-column prop="reward_rule" label="表现分">
                        <template slot-scope="props">

                            <el-input v-model="props.row.score" placeholder="表现分"></el-input>

                        </template>

                    </el-table-column>
                    <el-table-column prop="reward_rule" label="优享券数量">
                        <template slot-scope="props">

                            <el-input v-model="props.row.coupon" placeholder="优享券数量"></el-input>

                        </template>

                    </el-table-column>

                    <el-table-column label="操作" width="80">

                        <template slot-scope="props">

                            <el-button type="text" style="color: red" @click="del(props.row)">删除</el-button>

                        </template>

                    </el-table-column>

                </el-table>
                <!-- 对话框底部按钮 -->
                <div style="display: flex; justify-content: center;margin-top:100px">
                   
                    <el-button type="primary" @click="onSubmit">确认</el-button>
                    <el-button @click="closeDialog">返回</el-button>
                </div>

            </el-form>



        </div>
    </el-dialog>
</template>

<script>
    var _this;

    export default {
        props: {
            isShow: Boolean
        },
        components: {},
        watch: {
            isShow(newData, oldData) {
                _this.show = true;

                _this.getCityCouponConf();

                _this.getCouponList();

            }
        },
        data() {
            return {
                show: false,

                
                // 下拉搜索优惠券
                value_Coupon_code: '',
                options_coupon_code: [],
                coupon_options_data: {
                    page: 1,
                    limit: 5

                },
                // 表现分表格数据
                scoreTableData: [{
                    num: '',
                    score: '',
                    coupon: ''
                }],

                selectPages_data: [],

               
                // 表单数据
                submit_data: {
                    coupon_mode_code: '',
                    status: '',
                    reward_rule: '',
                    coupon_name: ''
                },
                search_data: {
                    type: '1'
                },

                submit_rules: {
                    coupon_mode_code: {
                        placeholder: '请选择优惠券',
                        rules: {
                            required: false,
                            message: '优惠券',
                            regulation: 'gt_str',
                            rulesData: '0'
                        }

                    }
                }
            };
        },
        created() {
            _this = this;
        },
        methods: {
            // 优惠券分页
            selectPages_function(search_data) {
                _this.coupon_options_data = search_data;

                _this.getCouponList();
            },

            // 删除
            del(obj) {
                console.log(obj,'obj');

                // 获取对应下标
                var index = _this.scoreTableData.indexOf(obj);

                this.scoreTableData.splice(index, 1);

            },
            // 增加
            addRules() {

                this.scoreTableData.push({
                    num: '',
                    score: '',
                    coupon: ''
                });
            },

            getCouponList() {
                // 获取所有新人优惠卷列表
                _this
                    .$post('Invitecode/getCouponList', _this.coupon_options_data)
                    .then((res) => {
                        _this.selectPages_data = res;
                        _this.options_coupon_code = res.data;

                    })
                    .catch((err) => {
                    });
            },

            //搜索的下拉框弹出触发
            couponVisibleChange(val) {
                _this.getCouponList();
            },
            couponChange(val) {
                console.log(val);

               


                _this.submit_data.coupon_mode_code = val;

            },


            // 关闭方法
            closeDialog() {

                _this.show = false;
                _this.submit_data = {
                    coupon_mode_code: '',
                    status: '',
                    coupon_name: ''

                };
                _this.scoreTableData = [{
                    num: '',
                    score: '',
                    coupon: ''
                }]

            },
            // 提交
            onSubmit() {



                // 遍历寻找coupon_code对应的name
                for(let i=0;i<_this.options_coupon_code.length;i++){

                    if(_this.options_coupon_code[i].coupon_mode_code == _this.submit_data.coupon_mode_code){
                        _this.submit_data.coupon_name = _this.options_coupon_code[i].name;
                        break;
                    }


                }



                let num_array=[];
                for(let i=0;i<_this.scoreTableData.length;i++){

                    if(_this.scoreTableData[i].num<0 ||_this.scoreTableData[i].score<0 ||_this.scoreTableData[i].coupon<0){
                        _this.$message.error('表单中存在负数')
                        return;
                    }


                    num_array.push(_this.scoreTableData[i].num)

                }

                if([...new Set(num_array)].length<_this.scoreTableData.length){
                    _this.$message.error('累计人数存在重复值')

                    return;
                }

                // 转化JSON字符串
                _this.submit_data.reward_rule = JSON.stringify(_this.scoreTableData);



                _this
                    .$post('/Invitecode/editCityCouponConf', _this.submit_data,_this.submit_rules)
                    .then((res) => {


                        _this.$message.success(res.msg);
                        _this.closeDialog();

                    })

            },
            // 获取配置
            getCityCouponConf() {
                _this.$post(
                    "/Invitecode/getCityCouponConf", {
                    type: 1
                },
                ).then(res => {

                    if (res.data.length != 0) {
                        // 提交过数据
                        _this.submit_data.coupon_mode_code = res.data.coupon_mode_code;
                        _this.value_Coupon_code = res.data.coupon_name;
                        _this.submit_data.status = res.data.status;
                        _this.submit_data.coupon_name = res.data.coupon_name;

                        if (res.data.reward_rule == '') {

                            _this.scoreTableData = [];

                        } else {
                            _this.scoreTableData = JSON.parse(res.data.reward_rule);
                        }

                    }



                }).catch((err) => {

                })


            },
          
        }
    };
</script>

<style scoped>
    .form-box {
        padding: 20px;
        box-sizing: border-box;
        margin-right: 0;
        width: 100%;
        height: 100%;
    }

    .active_config {
        font-weight: 700;
    }
</style>